import React from 'react';

import { IconProps } from './types';

const SendIcon: React.FC<IconProps> = props => {
  const {
    width = '42',
    height = '68',
    opacity = '1',
    fillColor = 'var(--blue-base)',
    fillColor1 = 'var(--blue-base)',
    className
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill={fillColor}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3816_1066)">
        <path
          d="M20.375 0.166845C20.3172 0.106491 20.2422 0.0653383 20.1602 0.0489454C20.0783 0.0325525 19.9933 0.0417089 19.9167 0.0751779L0.749997 8.33351C0.679145 8.36642 0.618506 8.41787 0.574497 8.48241C0.530489 8.54696 0.504747 8.6222 0.499997 8.70018C0.497495 8.7788 0.517296 8.85652 0.557113 8.92435C0.59693 8.99219 0.655135 9.04737 0.724997 9.08351L6.28333 12.0252C6.31651 12.0477 6.3557 12.0598 6.39583 12.0598C6.43596 12.0598 6.47515 12.0477 6.50833 12.0252L15.0833 5.08351C15.1235 5.05342 15.1731 5.03881 15.2231 5.04237C15.2731 5.04592 15.3202 5.0674 15.3556 5.10286C15.3911 5.13832 15.4126 5.18539 15.4161 5.23541C15.4197 5.28543 15.4051 5.33506 15.375 5.37518L8.45833 13.9502C8.43576 13.9834 8.42369 14.0226 8.42369 14.0627C8.42369 14.1028 8.43576 14.142 8.45833 14.1752L11.4 19.7335C11.4341 19.804 11.4874 19.8634 11.5537 19.9049C11.62 19.9465 11.6967 19.9686 11.775 19.9686C11.8533 19.9686 11.93 19.9465 11.9963 19.9049C12.0626 19.8634 12.1159 19.804 12.15 19.7335L20.5 0.625178C20.5296 0.545289 20.5334 0.458149 20.511 0.375962C20.4886 0.293774 20.441 0.220656 20.375 0.166845Z"
          fill={fillColor1}
        />
      </g>
      <defs>
        <clipPath id="clip0_3816_1066">
          <rect width="20" height="20" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SendIcon;
